import { CommonModule, DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ConfirmationService, MessageService } from "primeng/api";
import { ButtonModule } from "primeng/button";
import { CheckboxModule } from "primeng/checkbox";
import { PrimeNG } from "primeng/config";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DialogModule } from "primeng/dialog";
import { ProgressBarModule } from "primeng/progressbar";
import { TableModule } from "primeng/table";
import { ToastModule } from "primeng/toast";
import { OpePit } from "src/app/models/OpePit";
import { OptionResponseDto } from "src/app/models/OptionResponseDto";
import { SearchOpeCriteria } from "src/app/models/SearchOpeCriteria";
import { OpeService } from "src/app/services/ope/ope.service";
import { PituploadService } from "src/app/services/pitupload/pitupload.service";
import { sharePitSevices } from "src/app/services/pitupload/sharePit.service";
import { shareOpeSevices } from "src/app/services/sharedservices/shareOpe.services";
import { DocBiPlan } from "src/domain/docBiPlan";
import { DocBiPlanDto } from "src/domain/docBiPlanDto";
import { DocPitBlob } from "src/domain/docPitBlob";

@Component({
  selector: 'app-pitupload-plans-publication',
  templateUrl: './pitupload-plans-publication.component.html',
  imports: [TableModule,CommonModule,FormsModule,CheckboxModule,ConfirmDialogModule,ToastModule,DialogModule,ProgressBarModule,ButtonModule,],
  styleUrls: ['./pitupload-plans-publication.component.scss'],
  providers: [DatePipe, MessageService, ConfirmationService]
})

export class PituploadPlansPublicationComponent implements OnInit {

  files: any[] = [];
  mediaShow: any[] = [];
  programmeseled!: OpePit;
  planslots: DocBiPlanDto[] = [];
  searchCrit!: SearchOpeCriteria;
  editPlanDialog = false;
  titlepopupEditPlan = "";
  selectedPlantoEditOrDelete!: DocBiPlan;
  fileUploader!: File | null;
  selectedDocPitToSubmit: DocBiPlan | null = null;
  iconeDocFile!: string;
  previewUrl: string | ArrayBuffer | null = null;
  Math = Math;
  extPubAll = 0;
  webPubAll = 0;


  options!: OptionResponseDto[];
  constructor(public messageService: MessageService, public pitService: PituploadService, private config: PrimeNG, private confirmationService: ConfirmationService, public datePipe: DatePipe, public sharePitSevices: sharePitSevices, public share: shareOpeSevices, private opeservice: OpeService) { }

  ngOnInit() {
    this.programmeseled = this.sharePitSevices.pituploadSelectedOpe;
    if (this.programmeseled) {
      this.planslots = [];
      this.getAllBiPlan();
    }
  }

  getAllBiPlan() {
    this.share.showprogressbar = true;
    this.pitService.getBiPlanByNumOpe(this.programmeseled.numOpe)
      .subscribe(res => {
        this.planslots = res;
        this.share.showprogressbar = false;
        this.updateCheckBoxPub(res);
      })
  }


  updateCheckBoxPub(plans: DocBiPlanDto[]) {
    this.extPubAll = (plans.length > 0 && plans.filter(p => (p.pubExt === 0 || p.pubExt == null)).length == 0) ? 1 : 0;
    this.webPubAll = (plans.length > 0 && plans.filter(p => (p.publication == 0 || p.publication == null)).length == 0) ? 1 : 0;
  }

  onchangePlan(plan: DocBiPlan) {
    this.files = [];
    this.mediaShow = [];
    this.selectedDocPitToSubmit = plan;
    this.titlepopupEditPlan = "Modifier le plan du bien N° : " + plan.biPitDto.nomCommercial;
    this.editPlanDialog = true;
  }

  pubExt(plan: DocBiPlan) {
    let objDel = structuredClone(plan);
    objDel.pubExt = (objDel.pubExt == 1) ? 0 : 1;
    this.pitService.patchPubBiPlan(objDel)
      .subscribe(res => {
        this.getAllBiPlan();
        let msgNotif = (res.pubExt == 1) ? "Publication Extranet activée" : "Publication Extranet désactivée";
        this.messageService.add({ severity: "success", summary: "Modification de plan " + res.nomCommercial, detail: msgNotif });
      })
  }

  pubExtAll() {
    this.extPubAll = (this.extPubAll == 1) ? 0 : 1;
    this.pitService.patchBiPlanAllPubEXT({ numOpe: this.programmeseled.numOpe, value: this.extPubAll })
      .subscribe(res => {
        this.getAllBiPlan();
        let msgNotif = (this.extPubAll == 1) ? "Publication des lots sur Extranet activée" : "Publication des lots sur Extranet désactivée";
        this.messageService.add({ severity: "success", summary: "Modification " + this.programmeseled.nom, detail: msgNotif });
      })
  }

  pubWeb(plan: DocBiPlan) {
    let objDel = structuredClone(plan);
    objDel.publication = (objDel.publication == 1) ? 0 : 1;
    this.pitService.patchPubBiPlan(objDel)
      .subscribe(res => {
        this.getAllBiPlan();
        let msgNotif = (res.publication == 1) ? "Publication Web activée" : "Publication Web désactivée";
        this.messageService.add({ severity: "success", summary: "Modification de plan " + res.nomCommercial, detail: msgNotif });
      })
  }

  pubWebAll() {
    this.webPubAll = (this.webPubAll == 1) ? 0 : 1;
    this.pitService.patchBiPlanAllPubWEB({ numOpe: this.programmeseled.numOpe, value: this.webPubAll })
      .subscribe(res => {
        this.getAllBiPlan();
        let msgNotif = (this.webPubAll == 1) ? "Publication des lots sur Web activée" : "Publication des lots sur Web désactivée";
        this.messageService.add({ severity: "success", summary: "Modification " + this.programmeseled.nom, detail: msgNotif });
      })
  }


  annulerEdit() {
    this.files = [];
    this.mediaShow = [];
    this.editPlanDialog = false;
  }

  deletePlan(plan: DocBiPlan) {
    this.share.showprogressbar = true;
    this.selectedPlantoEditOrDelete = plan;
    if (plan.eiBinPitBinDto) plan.eiBinPitBinDto.bblob = "";
    this.pitService.deleteBiPlan(plan)
      .subscribe({
        next: (res) => {
          this.share.showprogressbar = false;
          this.getAllBiPlan();
          this.messageService.add({ severity: "success", summary: "Suppression de plan " + plan.biPitDto.nomCommercial, detail: "Suppression avec succes" });
        },
        error: (err) => {
          this.messageService.add({ severity: 'error', summary: "Erreur " + err.status, detail: err.message });
          this.share.showprogressbar = false;
        }
      })
  }

  confirm2(plan: any) {
    this.confirmationService.confirm({
      header: 'Confirmation',
      message: 'Valider la suppression ?',
      acceptLabel: 'Oui',
      accept: () => {
        this.deletePlan(plan);
      },
      rejectLabel: 'Non'
    });
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    this.fileUploader = file;
    // console.log(file);
    this.iconeDocFile = this.getIconFile(file.name);
    this.handleFile(file);
  }


  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    if (event.dataTransfer?.files.length) {
      const file = event.dataTransfer.files[0];
      this.iconeDocFile = this.getIconFile(file.name);
      this.handleFile(file);
    }
  }

  handleFile(file: File) {
    if (file && (file.type.startsWith('image/') ||
      file.type.startsWith('text/plain') ||
      file.type.startsWith('application/vnd.openxmlformats-officedocument.wordprocessingml.document') ||
      file.type.startsWith('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') ||
      file.type.startsWith('application/vnd.openxmlformats-officedocument.presentationml.presentation') ||
      file.type.startsWith('application/x-zip-compressed') ||
      file.type.startsWith('application/pdf')
    )) {
      this.fileUploader = file;
      this.files.push(file);
      const reader = new FileReader();
      reader.onload = (e) => {
        this.previewUrl = reader.result;

      }
      reader.readAsDataURL(file);

      // send to backend 
      //    this.messageService.add({ severity: 'success', summary : "Upload", detail: "Publication Web désactivée" });
    } else {
      this.messageService.add({ severity: 'error', summary: "Le fichier n'est pas accepté ", detail: file.type });
    }
  }

  formatSize(bytes: any) {
    const k = 1024;
    const dm = 3;
    const sizes = this.config.translation.fileSizeTypes;;
    if (bytes === 0) {
      return `0 ${sizes![0]}`;
    }

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const formattedSize = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));

    return `${formattedSize} ${sizes![i]}`;
  }

  deletelocalMedia() {
    this.fileUploader = null;
  }

  saveEdit() {
    let blobString = (this.previewUrl as string).substr((this.previewUrl as string).lastIndexOf(',') + 1)
    let docPitBob: DocPitBlob = {
      bcode: null,
      bnom: this.fileUploader?.name,
      btype: "",
      bblob: blobString,
      btaille: this.fileUploader?.size
    }
    if (this.fileUploader != null && this.selectedDocPitToSubmit) {
      this.selectedDocPitToSubmit.eiBinPitBinDto = docPitBob;
      this.selectedDocPitToSubmit.eiBinPitBinDto.bcode = this.selectedDocPitToSubmit.bcode;
      this.selectedDocPitToSubmit.eiBinPitBinDto.btype = this.fileUploader.name.substring(this.fileUploader.name.lastIndexOf('.') + 1);
      this.selectedDocPitToSubmit.nomFichier = this.fileUploader.name.substring(0, this.fileUploader.name.lastIndexOf('.'));

    }
    if (this.selectedDocPitToSubmit) {
      this.selectedDocPitToSubmit.dm = this.datePipe.transform(new Date, 'yyyy-MM-ddThh:mm:ssZ')?.toString();
      this.share.showprogressbar = true;
      this.pitService.updateBiPlanPit(this.selectedDocPitToSubmit).subscribe({
        next: (res) => {
          this.messageService.add({ severity: 'success', summary: "Modification", detail: "Le plan " + this.selectedDocPitToSubmit?.biPitDto.nomCommercial + " est modifié avec succès" });
          this.share.showprogressbar = false;
          this.getAllBiPlan();
          this.editPlanDialog = false;
        },
        error: (err) => {
          this.messageService.add({ severity: 'error', summary: "Erreur " + err.status, detail: err.message });
          this.share.showprogressbar = false;
        }
      });
    }
  }

  previsualisation() {

  }

  getIconFile(filename: string): string {
    let ext = filename.substr(filename.lastIndexOf('.') + 1);
    if (ext.toUpperCase() === 'PDF') { return 'assets/images/icons/icon-pdf.svg' };
    if (ext.toUpperCase() === '7Z', ext.toUpperCase() === 'ZIP') { return 'assets/images/icons/icon-zip.svg' };
    if (ext.toUpperCase() === 'JPG' || ext.toUpperCase() === 'PNG' || ext.toUpperCase() === 'JPEG') { return 'assets/images/icons/icon-document-invert.svg' };
    if (ext.toUpperCase() === 'DOCX' || ext.toUpperCase() === 'DOC') { return 'assets/images/icons/icon-doc.svg' };
    if (ext.toUpperCase() === 'TXT' || ext.toUpperCase() === 'XLSX' || ext.toUpperCase() === 'PPTX') { return 'assets/images/icons/icon-doc.svg' };
    return 'assets/images/icons/icon-zip.svg';
  }
}
